import withInputFields from "../../helpers/inputfields";
import withReactiveFields from "../../helpers/reactivefields";
import { USES_CHARGE_POLLING } from "../../../../charge/flags";
import { getValueAtPath, withProperties } from "../../../../utils";
import { selectNetworkFromList } from "../../../../collections/mobilemoneynetworks";
import getChargeLimit from "../../../../lookup/limit";
import getChargeFee from "../../../../lookup/fee";
import PendingView from "../../common/pending";
import ErrorState from "../../../common/error";

import InitView from "./views/init";
import ConfirmView from "./views/confirm";
import withCountdownTimer from "../../helpers/countdowntimer";

const METHOD = 'mpesa';
const METHOD_NAME = 'Mobile Money';
const CHARGE_MODE = USES_CHARGE_POLLING;

const VIEWS = [ InitView, ConfirmView ];

function mount() {
  return (dispatch) => {
    // Some logic here to determine the view to show instead of
    // always showing the form (first) view, nd also other stuffs
    // like fee check, limit check, etc.
    getChargeLimit.call(this, () => {
      InitView && InitView.activate();
    });

    getChargeFee();
  };
}

function getChargeData() {
  return ({
    is_mpesa: true,
    is_mpesa_lipa: true,
    payment_type: 'mpesa'
  });
}

function getViewsContext(data, store) {
  const TIMER_DURATION = 5 * 60;
  const NETWORKS = getValueAtPath(data, 'mobilemoney_networks[KE]');
  const REACTIVE_FIELDS = ['CURRENT_TIME', 'FALLBACK_DETAILS', 'MPESA_INSTRUCTION', 'MPESA_SECONDARY_INSTRUCTION', 'CAN_SWITCH_TO_CONFIRM'];
  const $context = withReactiveFields(Object.create(null), ...REACTIVE_FIELDS);

  $context.$subscribe('CAN_SWITCH_TO_CONFIRM', (currentValue, oldValue) => {
    setTimeout(() => {
      if (!(oldValue || oldValue === currentValue) && currentValue === true && typeof currentValue === 'boolean') {
        ConfirmView && ConfirmView.activate(() => {
          setTimeout(() => {
              $context.$charge.poll($context.pollConfig);
          }, 0);
        });
      }
    })
  })

  withInputFields($context, {
    phone: getValueAtPath(data, 'phone') || null,
    network: {
      options: NETWORKS,
      selector: selectNetworkFromList.bind($context, NETWORKS),
      defaultValue: getValueAtPath(data, 'mobilemoney_network') || null
    }
  });

  withProperties($context, {
    TIMER_DURATION,
    $resetContext() {
      // $context.CAN_GO_BACK = true;
      $context.FALLBACK_DETAILS = $context.MPESA_INSTRUCTION = $context.MPESA_SECONDARY_INSTRUCTION = $context.CAN_SWITCH_TO_CONFIRM = null;
      $context.mpesaOverrideTimeout && clearTimeout($context.mpesaOverrideTimeout);
      $context.mpesaOverrideTimeout = null;
      $context.mpesaPollingCompleted = false;
    },

    INIT_VIEW: callback => {
      InitView && (
        $context.$resetContext(),
        InitView.activate(callback)
      );
    }
  });

  return withCountdownTimer($context, {
    duration: TIMER_DURATION,
    onTick() { $context.CURRENT_TIME = $context.$timer.current },
    onFinish() {
      if ($context.$charge.cancel()) {
        $context.$timer && $context.$timer.clear();
        $context.CURRENT_TIME = null;
        $context.reference = null;
        $context.$resetContext();
        setTimeout(() => {
          ErrorState.actions.updateErrorMessage('');
          PendingView && PendingView.activate.call($context);
        }, 10)
      }
    }
  })
}

export {
  METHOD,
  METHOD_NAME,
  CHARGE_MODE,
  VIEWS,
  mount,
  getChargeData,
  getViewsContext
}
